// extracted by mini-css-extract-plugin
export default {"gif":"n_bd","gif--wrapped":"n_bf"};